"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _marketplace = require("../../store/marketplace/marketplace.actions");

var _marketplace2 = require("../../store/marketplace/marketplace.selector");

var _gift = require("../../store/gift/gift.selector");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      borderTop: "1px solid ".concat(palette.dividerLight)
    },
    menuItem: {
      display: 'flex'
    },
    costItem: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
});

var ProductPriceDropdown = function ProductPriceDropdown(_ref2) {
  var _product$giftCardRang3;

  var product = _ref2.product;
  var classes = useStyles();
  var optionsList = (0, _react.useMemo)(function () {
    var _product$giftCardRang;

    return (product === null || product === void 0 ? void 0 : (_product$giftCardRang = product.giftCardRange) === null || _product$giftCardRang === void 0 ? void 0 : _product$giftCardRang.denominations.map(function (price) {
      var _product$giftCardRang2;

      return {
        label: "".concat(price).concat(product === null || product === void 0 ? void 0 : (_product$giftCardRang2 = product.giftCardRange) === null || _product$giftCardRang2 === void 0 ? void 0 : _product$giftCardRang2.currencySign),
        value: price
      };
    })) || [];
  }, [product]);
  var proposedProducts = (0, _reactRedux.useSelector)(_gift.getGiftProposedProducts);
  var dispatch = (0, _reactRedux.useDispatch)(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  var convertedPrice = (0, _reactRedux.useSelector)(_marketplace2.getMarketplaceConvertedPrices);
  var minValue = (product === null || product === void 0 ? void 0 : (_product$giftCardRang3 = product.giftCardRange) === null || _product$giftCardRang3 === void 0 ? void 0 : _product$giftCardRang3.minPrice) || 0;
  var defaultValue = minValue;

  if (proposedProducts.length) {
    var _proposedProducts$0$p;

    defaultValue = (_proposedProducts$0$p = proposedProducts[0].price) !== null && _proposedProducts$0$p !== void 0 ? _proposedProducts$0$p : minValue;
  }

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var getExchangePrice = (0, _react.useCallback)(function (value) {
    var _convertedPrice$find;

    return convertedPrice ? (convertedPrice === null || convertedPrice === void 0 ? void 0 : (_convertedPrice$find = convertedPrice.find(function (item) {
      return item.price === value;
    })) === null || _convertedPrice$find === void 0 ? void 0 : _convertedPrice$find.convertedPrice) || null : null;
  }, [convertedPrice]);
  (0, _react.useEffect)(function () {
    var _product$giftCardRang4;

    dispatch((0, _marketplace.setValueRangedProduct)(minValue));

    if ((product === null || product === void 0 ? void 0 : (_product$giftCardRang4 = product.giftCardRange) === null || _product$giftCardRang4 === void 0 ? void 0 : _product$giftCardRang4.currencyId) !== 1) {
      var _product$giftCardRang5;

      dispatch((0, _marketplace.loadExchangeRatesRequest)(product === null || product === void 0 ? void 0 : (_product$giftCardRang5 = product.giftCardRange) === null || _product$giftCardRang5 === void 0 ? void 0 : _product$giftCardRang5.denominations.map(function (price) {
        var _product$giftCardRang6;

        return {
          fromCurrencyId: product === null || product === void 0 ? void 0 : (_product$giftCardRang6 = product.giftCardRange) === null || _product$giftCardRang6 === void 0 ? void 0 : _product$giftCardRang6.currencyId,
          toCurrencyId: 1,
          price
        };
      })));
    }
  }, [dispatch, minValue, product]);
  var handleChange = (0, _react.useCallback)(function (_ref3) {
    var price = _ref3.price;
    setLocalValue(price);
    dispatch((0, _marketplace.setValueRangedProduct)(price));
  }, [setLocalValue, dispatch]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.headerWrapper
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
    fullWidth: true,
    margin: "normal",
    onFilterChange: handleChange,
    renderItems: function renderItems() {
      return optionsList === null || optionsList === void 0 ? void 0 : optionsList.map(function (price) {
        var _product$giftCardRang7;

        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: price.value,
          value: price.value,
          className: classes.menuItem
        }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
          container: true,
          className: classes.costItem
        }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
          item: true
        }, price.label), (product === null || product === void 0 ? void 0 : (_product$giftCardRang7 = product.giftCardRange) === null || _product$giftCardRang7 === void 0 ? void 0 : _product$giftCardRang7.currencyId) !== 1 && /*#__PURE__*/_react.default.createElement(_material.Grid, {
          item: true
        }, getExchangePrice(price.value), "$")));
      });
    },
    value: localValue,
    name: "price",
    label: ""
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductPriceDropdown);

exports.default = _default;